import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import goodJobSvg from '../../images/goodJob.svg';
import CircularProgress from '@material-ui/core/CircularProgress';
import Transition from './Transition';

const styles = {
	goodJobIcon: {
		display : 'inline-block',
		width : 50,
		height : 50,
		backgroundImage: `url('${goodJobSvg}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
	},
	title : {
		fontSize : 30,
		display: 'inline-block',
		verticalAlign: 'middle',
		paddingLeft: 5,
		paddingTop: 5,
	}
};

export default class SuccessDialog extends Component {
	constructor (props) {
		super(props);
		this.handleRequestClose = this.handleRequestClose.bind(this);
	}

	handleRequestClose() {
		this.props.onClose();
	}
	render() {
		const { status } = this.props;
		return (
			<div>
				<Dialog
					open={this.props.open}
					TransitionComponent={Transition}
					onClose={this.handleRequestClose}
				>
					<DialogTitle>
						<div>
							{status !== 'done' &&
								<div>
									<CircularProgress />
									<span style={styles.title}>Processing Delivery...</span>
								</div>
							}
							{status === 'done' &&
								<div>
									<div style={styles.goodJobIcon}/>
									<span style={styles.title}>Success!</span>
								</div>
							}
						</div>
					</DialogTitle>
					<DialogContent>

						{status !== 'done' &&
						<DialogContentText>
							<span>Scheduling delivery and sending delivery request emails to carrier.</span>
						</DialogContentText>
						}

						{status === 'done' &&
						<DialogContentText>
							Carrier emails sent and delivery successfully scheduled.
						</DialogContentText>
						}
					</DialogContent>
					<DialogActions>
						<Button
							disabled={status !== 'done'}
							onClick={this.handleRequestClose}
							color="primary"
						>
							Continue
						</Button>
					</DialogActions>
				</Dialog>
			</div>
		);
	}
}

SuccessDialog.propTypes = {
	status : PropTypes.string,
	open : PropTypes.bool,
	onClose : PropTypes.func,
};